import { appColors } from '@/src/theme'
import { Flex, Text } from '@chakra-ui/react'
import type { FC } from 'react'

interface AvatarProps {
  name: string
  width?: string
  height?: string
  fontSize?: string
  maxChars?: number
}

export const Avatar: FC<AvatarProps> = ({ name, width, height, fontSize, maxChars }) => {
  const separatedWords = name.split(' ')
  const initials = separatedWords
    .map(word => word[0])
    .join('')
    .slice(0, maxChars !== undefined ? maxChars : 2)

  return (
    <Flex
      borderRadius='99999px'
      height={height ? height : '48px'}
      width={width ? width : '48px'}
      color={appColors.primary}
      backgroundColor={appColors.blue[100]}
      alignItems='center'
      justifyContent='center'
      padding={1}
      flexShrink={0}
    >
      <Text fontSize={fontSize ? fontSize : 18}>{initials}</Text>
    </Flex>
  )
}
